import { useEffect, useState } from 'react';
import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';

export function useDashboard() {
  const showToaster = useShowToaster();

  const fetchSpentChart = async (params) => {
    try {
      const res = await instance.get('/dashboard/statistics', { params });
      return res.data;
    } catch (err) {
      showToaster('error', err?.response?.data?.message);
    }
  };

  return { fetchSpentChart };
}

export function useSpentStatistics(params) {
  const { fetchSpentChart } = useDashboard();
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchSpentChart(params);
      setStatistics(data?.statistics);
    };
    fetchData();
  }, [params?.user_id, params?.group_id]);

  return { statistics };
}
